import { api } from "@lib/orpc-client"
import useSWR from "swr"

const useSupportedVirtualAccount = () => {
    const {data, error, isLoading} = useSWR(
        'walletV2.virtualAccount.supported',
        () => api.walletV2.virtualAccount.supported({})
    )
    return {
        data,
        isLoading,
        error
    }
}

export default useSupportedVirtualAccount
